import { render, staticRenderFns } from "./extra-projekt-planung.vue?vue&type=template&id=4de31f6a&lang=pug&"
import script from "./extra-projekt-planung.vue?vue&type=script&lang=js&"
export * from "./extra-projekt-planung.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports